import { AbstractParentEntity } from "./AbstractParentEntity";
import { Course } from "./tsadv$Course";
import { DicLearningCenter } from "./tsadv$DicLearningCenter";
import { Trainer } from "./tsadv$Trainer";
import { PartyExt } from "./base$PartyExt";
import { MeetingMinutes } from "./tsadv_MeetingMinutes";
export class CourseSchedule extends AbstractParentEntity {
  static NAME = "tsadv_CourseSchedule";
  course?: Course | null;
  name?: string | null;
  startDate?: any | null;
  endDate?: any | null;
  duration?: any | null;
  learningCenter?: DicLearningCenter | null;
  address?: string | null;
  maxNumberOfPeople?: number | null;
  trainer?: Trainer | null;
  provider?: PartyExt | null;
  meetingMinutes?: MeetingMinutes | null;
}
export type CourseScheduleViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "courseSchedule.edit"
  | "courseScheduleEvent-browse"
  | "courseScheduleEvent-edit";
export type CourseScheduleView<
  V extends CourseScheduleViewName
> = V extends "_base"
  ? Pick<
      CourseSchedule,
      | "id"
      | "name"
      | "startDate"
      | "endDate"
      | "duration"
      | "address"
      | "maxNumberOfPeople"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_local"
  ? Pick<
      CourseSchedule,
      | "id"
      | "name"
      | "startDate"
      | "endDate"
      | "duration"
      | "address"
      | "maxNumberOfPeople"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
    >
  : V extends "_minimal"
  ? Pick<CourseSchedule, "id" | "name">
  : V extends "courseSchedule.edit"
  ? Pick<
      CourseSchedule,
      | "id"
      | "name"
      | "startDate"
      | "endDate"
      | "duration"
      | "address"
      | "maxNumberOfPeople"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "course"
      | "learningCenter"
    >
  : V extends "courseScheduleEvent-browse"
  ? Pick<
      CourseSchedule,
      | "id"
      | "name"
      | "startDate"
      | "endDate"
      | "duration"
      | "address"
      | "maxNumberOfPeople"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "course"
      | "learningCenter"
      | "trainer"
      | "provider"
      | "meetingMinutes"
    >
  : V extends "courseScheduleEvent-edit"
  ? Pick<
      CourseSchedule,
      | "id"
      | "name"
      | "startDate"
      | "endDate"
      | "duration"
      | "address"
      | "maxNumberOfPeople"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "course"
      | "learningCenter"
      | "trainer"
      | "provider"
      | "meetingMinutes"
    >
  : never;
